let store = null;

export default {
  init(configureStore) {
    store = configureStore();
  },
  getStore() {
    return store;
  },
};
